import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { CreateCommitmentDialog } from "@/services/backend/relationships/components/create-commitment-dialog";
import {
  CommitmentsTable,
  CommitmentsTableFilters,
} from "@/services/backend/relationships/components/commitments-table";
import {
  Commitment,
  Relationship,
} from "@/services/backend/relationships/types/relationship";
import { ReactNode, useState } from "react";
import { ListCommitmentsRequest } from "@/services/backend/relationships/api/service";

export function CommitmentsCard({
  relationship,
  renderCommitmentLink,
  renderDocumentLink,
}: {
  relationship: Relationship;
  renderCommitmentLink: (
    commitment: Commitment,
    relationship: Relationship,
    children: ReactNode,
  ) => ReactNode;
  renderDocumentLink: (path: string, children: ReactNode) => ReactNode;
}) {
  const [request, setRequest] = useState<ListCommitmentsRequest>({
    relationship: {
      active: true,
      values: [relationship.id],
    },
    limit: 10,
  });
  const [selection, setSelection] = useState<Commitment[]>([]);

  return (
    <Card>
      <CardHeader className="grid grid-cols-1 sm:grid-cols-[1fr_auto]">
        <div>
          <CardTitle>{t("Sollstellungen")}</CardTitle>
          <CardDescription>
            {t("Diese Sollstellungen bestehen im Rahmen der Beziehung.")}
          </CardDescription>
        </div>
        <CreateCommitmentDialog relationship={relationship} />
      </CardHeader>
      <CardContent>
        <div className="grid gap-2">
          <CommitmentsTableFilters
            request={request}
            onRequestChange={setRequest}
            selection={selection}
            onSelectionChange={setSelection}
          />
          <CommitmentsTable
            request={request}
            onRequestChange={setRequest}
            selection={selection}
            onSelectionChange={setSelection}
            renderCommitmentLink={renderCommitmentLink}
            renderDocumentLink={renderDocumentLink}
          />
        </div>
      </CardContent>
    </Card>
  );
}
